type Params = {
  templateIds: number[]
  placeNodeUuids: string[]
  availableTemplateIds: Set<number>
  /** 現場一覧が取得できない場合は null を渡して現場整流をスキップする。 */
  availablePlaceUuids: Set<string> | null
}

type Result = {
  prunedTemplateIds: number[]
  prunedPlaceUuids: string[]
  droppedTemplateCount: number
  droppedPlaceCount: number
  /** 除外件数が 1 件以上のとき表示するユーザー向け通知。除外なしなら undefined。 */
  notice: string | undefined
}

/**
 * 再出力プリフィル後、現存しないひな形/現場を form 値から除外する。
 * Snackbar の通知メッセージも合わせて組み立てる。
 *
 * - 死んだ id がそのまま送信されるのを防ぐ
 * - 削除件数が 0 のとき notice は undefined（通知不要）
 * - 現場一覧が取得できないケース(`availablePlaceUuids === null`)では、
 *   現場の整流をスキップし、入力値をそのまま返す
 */
export const pruneReexportConditions = ({
  templateIds,
  placeNodeUuids,
  availableTemplateIds,
  availablePlaceUuids,
}: Params): Result => {
  const prunedTemplateIds = templateIds.filter(id =>
    availableTemplateIds.has(id),
  )
  const droppedTemplateCount = templateIds.length - prunedTemplateIds.length

  const prunedPlaceUuids =
    availablePlaceUuids !== null
      ? placeNodeUuids.filter(uuid => availablePlaceUuids.has(uuid))
      : placeNodeUuids
  const droppedPlaceCount = placeNodeUuids.length - prunedPlaceUuids.length

  const notices: string[] = []
  if (droppedTemplateCount > 0) notices.push(`ひな形${droppedTemplateCount}件`)
  if (droppedPlaceCount > 0) notices.push(`現場${droppedPlaceCount}件`)
  const notice =
    notices.length > 0
      ? `削除された${notices.join('・')}を除外しました`
      : undefined

  return {
    prunedTemplateIds,
    prunedPlaceUuids,
    droppedTemplateCount,
    droppedPlaceCount,
    notice,
  }
}
